<template>
  <div>
    <v-row>
      <v-col cols="12" md="7" lg="5">
        <h3 class="mb-2">Scholars Result di syncrhonous</h3>
      </v-col>
      <v-col cols="12" md="7" lg="7">
        <div class="d-flex justify-end" v-if="!readonly">
          <v-btn
            class="text-capitalize"
            @click="dialog = true"
            height="38px"
            color="white"
          >
            <v-icon color="green">mdi-file-sign</v-icon>
            Add review
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <div v-if="dataSet && !loading" min-height="300px">
      <div v-if="dataSet.length">
        <v-expansion-panels>
          <v-expansion-panel
            class="rounded-lg my-2"
            v-for="(item, i) in dataSet"
            :key="`sect_${i}`"
            elevation="1"
          >
            <v-expansion-panel-header class="pa-3">
              <div class="d-flex align-center pa-2">
                <router-link
                  class="opener_name"
                  :to="`/scholar/${item.data_scholar.user_id}`"
                >
                  <v-avatar size="40" class="mr-2">
                    <img
                      :src="
                        item.data_scholar.profile_picture
                          ? item.data_scholar.profile_picture
                          : ava
                      "
                      class="obj_fit"
                      alt="isyan"
                    />
                  </v-avatar>
                </router-link>
                <div>
                  <div class="d-flex align-center">
                    <router-link
                      class="opener_name"
                      :to="`/scholar/${item.data_scholar.user_id}`"
                    >
                      <h3 style="color: #006341">
                        {{ item.data_scholar.name }}
                      </h3>
                    </router-link>
                    <small
                      class="ml-1 grey--text"
                      style="color: rgba(0, 0, 0, 0.4)"
                    >
                      · {{ $date(item.updated_at).fromNow() }}</small
                    >
                  </div>
                  <p class="default_txt mt-2">
                    {{
                      item.data_scholar.no_tf ? item.data_scholar.no_tf : "-"
                    }}
                  </p>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <v-checkbox
                  :disabled="readonly"
                  v-model="item.present"
                  label="Presence"
                  color="green"
                  hide-details
                  class="ma-0"
                ></v-checkbox>
                <div class="my-2">
                  <b>Score</b>
                  <v-card
                    class="pa-2 d-flex align-center jusitfy-center"
                    outlined
                    width="max-content"
                  >
                    <div class="d-flex align-center">
                      <input
                        type="tel"
                        class="input_score"
                        v-model="item.score"
                      />
                      <h4 style="color: #a2aaad">/100</h4>
                    </div>
                  </v-card>
                </div>
                <div class="my-2">
                  <b>Notes</b>
                  <v-textarea
                    hide-details
                    class="my-1 rounded"
                    rows="4"
                    background-color="#f6f6f6"
                    solo
                    flat
                    placeholder="Type here..."
                    auto-grow
                    v-model="item.notes"
                  ></v-textarea>
                </div>
                <div v-if="!readonly" class="d-flex justify-end mt-2">
                  <v-btn
                    v-if="!sending"
                    depressed
                    dark
                    class="text-capitalize"
                    color="var(--g)"
                    @click="giveReview(item)"
                  >
                    send
                  </v-btn>
                  <v-btn
                    v-if="sending"
                    depressed
                    dark
                    class="text-capitalize"
                    color="var(--g)"
                  >
                    sending...
                  </v-btn>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <div class="empty" v-if="!loading && !dataSet.length">
        <div class="pa-3 my-3 align-center justify-center d-flex flex-column">
          <img
            src="../../../../assets/img/redaksi/pagenotfound.png"
            height="150px"
            alt=""
          />
          <b class="default_txt my-3">Data not found</b>
        </div>
      </div>
    </div>
    <div v-if="loading">
      <v-card class="my-2 pa-3 rounded-lg" v-for="i in 3" :key="i">
        <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
      </v-card>
    </div>
    <div class="text-center pa-3" v-if="dataSet">
      <v-pagination
        v-if="dataSet.length"
        v-model="page"
        :color="color"
        @input="fetchData"
        :length="last_page"
      ></v-pagination>
    </div>
    <div class="pa-3">
      <review-sync
        :dialog="dialog"
        @refetch="fetchData"
        @close="dialog = false"
        :inventory="inventory"
        :type="d_type"
        :title="'Review'"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import reviewSync from "./modal/reviewSync.vue";
export default {
  components: { reviewSync },
  name: "resultSync",
  props: ["color", "title", "readonly"],
  data() {
    return {
      dataSet: null,
      loading: false,
      sending: false,
      page: 1,
      limit: 10,
      total: null,
      last_page: null,
      find: "",
      notes: "",
      myNotes: null,

      dialog: false,
      inventory: null,
      d_type: null,
      d_title: null,
    };
  },
  mounted() {
    this.fetchData(true);
  },
  computed: {
    ...mapState({
      ava: (state) => state.ava,
      id: (state) => state.id,
      role: (state) => state.role,
      permissions: (state) => state.permissions,
    }),
  },
  methods: {
    fetchData(first) {
      if (first) {
        this.loading = true;
      }
      let instance = this.$route.params.idInstance;
      let data = {
        path: `manage/course/section/synchronus/list/report?course_synchronous_id=${instance}&filter[search]=${this.find}&page[number]=${this.page}&page[size]=${this.limit}&include=dataUser,dataScholar`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.dataSet = data.data;
          this.dataSet.forEach((el) => {
            if (el.attendance == "presence") {
              el["present"] = true;
            } else {
              el["present"] = false;
            }
          });
          this.total = data.total;
          this.last_page = data.last_page;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },

    giveReview(item) {
      this.sending = true;
      let instance = this.$route.params.idInstance;
      let body = {
        course_synchronous_id: instance,
        scholar_id: item.scholar_id,
        attendance: item.present ? "presence" : "absence",
        score: item.score,
        notes: item.notes,
      };
      let data = {
        path: `manage/course/section/synchronus/update/report`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.fetchData();
          this.$emit("fetch");
          this.sending = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
        })
        .catch((e) => {
          if (e.data) {
            var key = Object.keys(e.data.errors);
            var values = Object.values(e.data.errors);
            for (let i = 0; i < key.length; i++) {
              for (let j = 0; j < values[i].length; j++) {
                this.$toast.error(values[i][j]);
              }
            }
          } else {
            this.$store.dispatch("notify", {
              msg: e.message,
              type: "error",
            });
          }
          this.sending = false;
        });
    },
  },
};
</script>

<style>
.strip-y {
  padding: 3px;
  width: 10px;
  max-height: 100%;
  border-radius: 0 !important;
}
.input_score {
  width: 50px;
}
.input_score:focus {
  outline: none;
}
</style>
